import qs from 'qs';
import axios from 'axios';
import Jsona from 'jsona';

const url = process.env.VUE_APP_API_BASE_URL;
const jsona = new Jsona();

function list(params) {
  const options = {
    params: params,
    paramsSerializer: function (params) {
      return qs.stringify(params, {encode: false});
    }
  };

  return axios.get(`${url}/workshop/workshop_warehouses`, options)
    .then(response => {
      return {
        list: jsona.deserialize(response.data),
        meta: response.data.meta
      };
    });
}
 
function get(id) {
  const options = {
    headers: {
      'Accept': 'application/vnd.api+json',
      'Content-Type': 'application/vnd.api+json',
    }
  };

  return axios.get(`${url}/workshop/workshop_warehouses/${id}`, options)
    .then(response => {
      let warehouse = jsona.deserialize(response.data);
      delete warehouse.links;
      return warehouse;
    });
}

function add(warehouse) {
  
  console.log(warehouse);
  const payload = jsona.serialize({
    stuff: warehouse,
    includeNames: null
  });
  console.log(payload);
  const options = {
    headers: {
      'Accept': 'application/vnd.api+json',
      'Content-Type': 'application/vnd.api+json',
    }
  };

  return axios.post(`${url}/workshop/workshop_warehouses`, payload, options)
    .then(response => {
      return jsona.deserialize(response.data);
    });
}

function update(warehouse) {
  const payload = jsona.serialize({
    stuff: warehouse,
    includeNames: []
  });

  const options = {
    headers: {
      'Accept': 'application/vnd.api+json',
      'Content-Type': 'application/vnd.api+json',
    }
  };
 
  return axios.patch(`${url}/workshop/workshop_warehouses/${warehouse.id}`, payload, options)
    .then(response => {
      return jsona.deserialize(response.data);
    });
}

function destroy(id) {
  const options = {
    headers: {
      'Accept': 'application/vnd.api+json',
      'Content-Type': 'application/vnd.api+json',
    }
  };

  return axios.delete(`${url}/workshop/workshop_warehouses/${id}`, options);
}



export default {
  list,
  get,
  add,
  update,
  destroy,
};

